import { render } from "./ModalAviso.vue?vue&type=template&id=e3f397c6"
import script from "./ModalAviso.vue?vue&type=script&lang=js"
export * from "./ModalAviso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__